export function OldieAntenneColorRotation (navigationHandler) {
    if (!document.documentElement.classList.contains('template--oldieantenne')) {
        return;
    }

    /**
     * Row 1: secondary color
     * Row 2: link hover on light background
     * Row 3: link hover on dark background
     */
    const colorSets = [
        ['#cd007b', '#cd007b', '#e00087'],
        ['#e2001a', '#e2001a', '#ed021e'],
        ['#ee7f00', '#b35f00', '#ee7f00'],
        ['#1fa22e', '#177d23', '#1fa22e'],
        ['#00519e', '#00519e', '#0074e0'],
    ];

    const docElement = document.documentElement;
    const cssProps = [
        '--antenne-color-secondary',
        '--antenne-color-linkhover-on-light',
        '--antenne-color-linkhover-on-dark',
    ];

    function setColors () {
        const randomIndex = Math.floor(Math.random() * colorSets.length);
        const [secondary, linkLight, linkDark] = colorSets[randomIndex];

        docElement.style.setProperty(cssProps[0], secondary);
        docElement.style.setProperty(cssProps[1], linkLight);
        docElement.style.setProperty(cssProps[2], linkDark);
    }

    // Set initial colors
    setColors();

    // Update colors on navigation render
    navigationHandler.on('render', setColors);
}
